import { LayoutEditorShell } from '../../../lib/form-layout/LayoutEditorShell';
import {
  LEASE_TRACT_FORM_FIELDS,
  LEASE_TRACT_FORM_FIELD_NAMES,
  LEASE_TRACT_DEFAULT_LAYOUT,
  type LeaseTractFormContext,
} from '../../../lib/form-layout/lease-tract-fields';
import {
  useAdminActiveLeaseTractLayout,
  useUpdateLeaseTractFormLayout,
} from '../../../queries/lease-tract-form-layout';
import type { LeaseTractInputSchema } from '../../../lib/schemas';

/**
 * Thin wrapper around LayoutEditorShell that wires the lease-tract-form's
 * registry / queries / preview context. Mechanical clone of
 * WellFormLayoutEditor.tsx / LeaseFormLayoutEditor.tsx — lease-tracts has no
 * lookup-backed selects, so unlike wells/leases there's no `useLandLookups()`
 * call here.
 */
export function LeaseTractFormLayoutEditor() {
  const previewDefaults: LeaseTractInputSchema = {
    agreement_number: '',
    type: null,
    status: null,
    reviewer_user_id: null,

    lessor: null,
    lessee: null,

    agreement_date: null,
    expiration_date: null,

    book: null,
    page: null,
    county: null,
    state: null,

    legal_description: null,
    legal_remark: null,
    all_depths: null,

    gross_acres: null,
    net_acres: null,

    royalty: null,
    orri_owner: null,
    orri_decimal: null,
    wi_owner: null,
    wi_decimal: null,
    other_burdens: null,
  };

  const previewContext: LeaseTractFormContext = {
    // The layout editor's preview form has no real project/session behind
    // it, so the reviewer Select has no members to offer —
    // canAssignAnyReviewer: true just keeps the (empty) option list
    // unfiltered rather than collapsing to a self-only view that can never
    // match anything here.
    members: [],
    canAssignAnyReviewer: true,
    currentUserId: 'preview',
  };

  return (
    <LayoutEditorShell
      title="Lease tract form layout"
      breadcrumbLabel="Lease tract form layout"
      registry={LEASE_TRACT_FORM_FIELDS}
      allNames={LEASE_TRACT_FORM_FIELD_NAMES}
      defaultLayout={LEASE_TRACT_DEFAULT_LAYOUT}
      useActive={useAdminActiveLeaseTractLayout}
      useUpdate={useUpdateLeaseTractFormLayout}
      previewDefaults={previewDefaults}
      previewContext={previewContext}
    />
  );
}
